import { SdkEventInterface } from "@modules/sdk/events/SdkEventInterface";

import { COMMON_SDK_EVENTS } from "../constants";

class ReviewsSdkReadySdkEvent implements SdkEventInterface {
    public readonly type = COMMON_SDK_EVENTS.REVIEWS_SDK_READY;
}

export default ReviewsSdkReadySdkEvent;
